/* TemplateMoto mockup pages: before / after slider.
   One delegated listener for every .tmm-compare on the page, plus a short hint animation
   the first time a slider scrolls into view (skipped when the visitor prefers less motion). */
(function () {
  if (window.tmmMockupReady) return;
  window.tmmMockupReady = true;

  function setPos(box, value) {
    box.style.setProperty('--pos', value + '%');
  }

  document.addEventListener('input', function (event) {
    var range = event.target;
    if (!range.classList || !range.classList.contains('tmm-compare__range')) return;
    var box = range.closest('.tmm-compare');
    if (!box) return;
    box.dataset.touched = '1';
    setPos(box, range.value);
  });

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  function hint(box) {
    var range = box.querySelector('.tmm-compare__range');
    if (!range) return;
    var frames = [50, 32, 68, 50];
    var start = null;
    var duration = 2200;

    function step(now) {
      if (box.dataset.touched) return;
      if (start === null) start = now;
      var t = Math.min((now - start) / duration, 1);
      var seg = Math.min(Math.floor(t * (frames.length - 1)), frames.length - 2);
      var local = t * (frames.length - 1) - seg;
      var eased = local < 0.5 ? 2 * local * local : 1 - Math.pow(-2 * local + 2, 2) / 2;
      var value = frames[seg] + (frames[seg + 1] - frames[seg]) * eased;
      range.value = value;
      setPos(box, value);
      if (t < 1) window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      window.setTimeout(function () { hint(entry.target); }, 400);
    });
  }, { threshold: 0.6 });

  function watch() {
    document.querySelectorAll('.tmm-compare').forEach(function (box) {
      if (box.dataset.watched) return;
      box.dataset.watched = '1';
      observer.observe(box);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  document.addEventListener('shopify:section:load', watch);
})();
